import '../../../styles/knowledge-concept/SideBar.css';

import { Box, Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { addNotebook, setNotebook, setNotebookList } from '../../../store/notebookSlice';
import { deleteNotebook, updateNotebookName } from '../../../services/DashboardApi';
import {
	fetchNoteBookList,
	getLatestNotebookId,
	saveNotebook,
} from '../../../services/DashboardApi';
import { useDispatch, useSelector } from 'react-redux';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Loader from '../../atoms/Loader';
import { logger } from '../../../utils/logger';

const SideBar = ({
	handleNoteBookSelection,
	setSidebarState,
	showLearningInterface,
	selectedSubTab,
	handleCreateNotebook,
	// setSelectedNotebookId,
	// selectedNotebookId,
}) => {
	const dispatch = useDispatch();
	const { notebookList, currentNotebook } = useSelector((state) => state.notebook);
	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);

	const [dropdownIndex, setDropdownIndex] = useState(null); // For toggling dropdown
	const [editIndex, setEditIndex] = useState(null);
	const [editName, setEditName] = useState('');
	const { userId } = useSelector((state) => state.userDetails);
	const [isLoading, setIsLoading] = useState(false);
	const selectedMainTab = useSelector((state) => state.mainTab.tab_name);

	const handleHeaderClick = (topicId, subTopicId, notebookId) => {
		dispatch(setNotebook(notebookId));
		handleNoteBookSelection(topicId, subTopicId, notebookId);
	};

	const handleEditClick = (notebookId, currentName) => {
		setEditIndex(notebookId); // Use NOTEBOOK_ID instead of index
		setEditName(currentName);
		setDropdownIndex(null); // Close dropdown when renaming
	};

	const handleEditSave = async (notebookId) => {
		try {
			//let userId = "1049";
			let updatedAt = new Date().toISOString();
			await updateNotebookName(notebookId, editName, userId, updatedAt);
			const updatedNotebookList = notebookList
				?.map((notebook) =>
					notebook.NOTEBOOK_ID === notebookId
						? { ...notebook, NOTEBOOK_HEADER: editName, UPDATED_AT: updatedAt }
						: notebook
				)
				.sort((a, b) => new Date(b.UPDATED_AT) - new Date(a.UPDATED_AT));
			dispatch(setNotebookList(updatedNotebookList));
			setEditIndex(null);
		} catch (error) {
			logger.log('Error updating notebook name:', error);
		}
	};

	const handleKeyDown = (e, notebookId) => {
		if (e.key === 'Enter') {
			handleEditSave(notebookId);
		} else if (e.key === 'Escape') {
			setEditIndex(null);
		}
	};

	const handleDropdownToggle = (notebookId) => {
		setEditIndex(null); // Reset editIndex when toggling dropdown
		setDropdownIndex(dropdownIndex === notebookId ? null : notebookId); // Use NOTEBOOK_ID
	};

	const handleShare = (notebookName) => {
		setDropdownIndex(null);
	};

	const handleArchive = (notebookName) => {
		setDropdownIndex(null);
	};

	const handleDelete = async (notebookId) => {
		setIsLoading(true);
		setDropdownIndex(null);
		logger.log('Notebook ID to delete: ', notebookId);

		try {
			await deleteNotebook(notebookId);

			// Filter out the deleted notebook from the notebookList
			const updatedNotebookList = notebookList.filter(
				(notebook) => notebook.NOTEBOOK_ID !== notebookId
			);

			// Dispatch the updated list to the Redux store
			dispatch(setNotebookList(updatedNotebookList));
			if (notebookList.length > 0) {
				const nextNotebook = updatedNotebookList[0];
				dispatch(setNotebook(nextNotebook.NOTEBOOK_ID));
				handleNoteBookSelection(
					nextNotebook.TOPIC_ID,
					nextNotebook.SUBTOPIC_ID,
					nextNotebook.NOTEBOOK_ID
				);
			}
		} catch (error) {
			logger.log('Error deleting notebook:', error);
		} finally {
			setIsLoading(false);
		}
	};

	logger.log('Notebook List: ', notebookList);

	useEffect(() => {
		const fetchData = async () => {
			let topicId = selectedSubTopicDetails.topicId;
			let subtopicId = selectedSubTopicDetails.subtopicId;
			logger.log('TopicId and SubtopicId inside useEffect of Sidebar: ', topicId, subtopicId);
			let identifier = '';
			if (!topicId && !subtopicId) {
				identifier = 'USER_SPECIFIC';
			} else {
				identifier = 'TOPIC_SUBTOPIC_SPECIFIC';
			}
			logger.log('Identifier inside useEffect of SideBar: ', identifier);
			const success = await fetchAndSetNoteBookList(identifier, topicId, subtopicId);
			if (success) {
				logger.log('Notebook List fetched successfully');
			}
		};

		fetchData();
	}, [selectedSubTopicDetails, selectedSubTab]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!event.target.closest('.sidebar-item')) {
				setDropdownIndex(null);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const fetchAndSetNoteBookList = async (identifier, topicId, subtopicId) => {
		// let userId = "1049";
		setIsLoading(true);
		try {
			const response = await fetchNoteBookList(userId, identifier, topicId, subtopicId);
			let responseData = response.data?.noteBookList;
			logger.log('Notebook list ##: ', responseData);
			if (responseData.length != 0) {
				responseData = responseData.sort(
					(a, b) => new Date(b.UPDATED_AT) - new Date(a.UPDATED_AT)
				);
				dispatch(setNotebookList(responseData));
			}
		} catch (error) {
			logger.log('Error fetching notebook list:', error);
		} finally {
			setIsLoading(false);
			return true;
		}
	};

	return (
		<aside className="sidebar">
			<Box sx={{ display: { xs: 'block', sm: 'none', alignItems: 'start' } }}>
				<IconButton onClick={() => setSidebarState(false)}>
					<ArrowBackIosIcon sx={{ color: '#fff' }} />
				</IconButton>
			</Box>
			{showLearningInterface && (
				<>
					<Button
						variant="contained"
						onClick={() => handleCreateNotebook('New Notebook')}
						size="medium"
						sx={{
							backgroundColor: '#07bd80',
							color: '#000',
							marginTop: '1rem',
							marginBottom: '1rem',
						}}
					>
						Create Notebook
					</Button>
				</>
			)}
			<h3>
				{selectedSubTab !== 'Notebook'
					? 'My Notebook'
					: selectedSubTopicDetails.subtopicName}
			</h3>
			{selectedSubTab === 'Notebook' && (
				<>
					<Box
						onClick={() =>
							handleHeaderClick(
								//i,
								notebookList[0].TOPIC_ID,
								notebookList[0].SUBTOPIC_ID,
								'default'
							)
						}
						sx={{
							cursor: 'pointer',
							mb: '2rem',
							display: 'flex',
							alignItems: 'center',
							padding: '1rem',
							border: '1px solid #fff',
							borderRadius: '15px',
							backgroundColor: '#001fff',
							...(currentNotebook === 'default' && {
								backgroundColor: '#08bd80',
								borderColor: '#fff',
							}),
						}}
					>
						{`${selectedSubTopicDetails.subtopicName} Information`}
					</Box>
					<h3 style={{ marginBottom: '1rem' }}>My Notebooks</h3>
				</>
			)}
			{isLoading ? (
				<Loader />
			) : (
				notebookList?.map((data, i) => (
					<div
						key={data.NOTEBOOK_ID}
						className={`sidebar-item ${
							currentNotebook === data.NOTEBOOK_ID ? 'active' : ''
						}`}
						style={{ position: 'relative' }}
					>
						{editIndex === data.NOTEBOOK_ID ? (
							<div className="edit-container">
								<input
									type="text"
									value={editName}
									onChange={(e) => setEditName(e.target.value)}
									onKeyDown={(e) => handleKeyDown(e, data.NOTEBOOK_ID)}
									className="edit-input"
									autoFocus
								/>
							</div>
						) : (
							<div>
								<div
									onClick={() =>
										handleHeaderClick(
											//i,
											data.TOPIC_ID,
											data.SUBTOPIC_ID,
											data.NOTEBOOK_ID
										)
									}
								>
									<h4>
										{data.NOTEBOOK_HEADER.length > 20
											? `${data.NOTEBOOK_HEADER.substring(0, 20)}...`
											: data.NOTEBOOK_HEADER}
									</h4>
								</div>
								{/* Dropdown Trigger */}
								<div
									className="three-dots-menu"
									onClick={() => handleDropdownToggle(data.NOTEBOOK_ID)}
								>
									&#x2022;&#x2022;&#x2022;
								</div>
								{/* Dropdown Menu */}
								{/* {dropdownIndex === i && ( */}
								{dropdownIndex === data.NOTEBOOK_ID && (
									<div className="dropdown-menu">
										{/* <button
                    className="dropdown-item"
                    onClick={() => handleShare(data.NOTEBOOK_HEADER)}
                  >
                    Share
                  </button> */}
										<button
											className="dropdown-item"
											// onClick={() => handleEditClick(i, data.NOTEBOOK_HEADER)}
											onClick={() =>
												handleEditClick(
													data.NOTEBOOK_ID,
													data.NOTEBOOK_HEADER
												)
											}
										>
											Rename
										</button>
										{/* <button
                    className="dropdown-item"
                    onClick={() => handleArchive(data.NOTEBOOK_HEADER)}
                  >
                    Archive
                  </button> */}
										<button
											className="dropdown-item danger"
											onClick={() => handleDelete(data.NOTEBOOK_ID)}
										>
											Delete
										</button>
									</div>
								)}
							</div>
						)}
					</div>
				))
			)}
		</aside>
	);
};

export default SideBar;
